import { useMutation } from 'react-query';
import axios from 'axios';
import { useTokenStore } from '../../storage/tokenState';
import { GET_ORDER_STATUS } from '../../appConstants/APIEndpoint';
import { LANGUAGE } from '../../constant';
import { getSubscriptionBaseUrl } from '../../utils/apiConfig';

interface OrderStatusResponse {
  en: string;
  success?: boolean;
  heading?: string;
  message?: string;
  orderStatus?: string;
  response: {
    success: boolean;
    data?: {
      orderId?: string;
      status?: string;
      amount?: number;
      createdAt?: number;
      updatedAt?: number;
    };
    error?: string;
  };
}

interface OrderStatusRequest {
  orderId: string;
  merchantName?: string;
}

export const useGetOrderStatus = () => {
  const { token } = useTokenStore();

  const mutation = useMutation<OrderStatusResponse, Error, OrderStatusRequest>(
    async ({ orderId, merchantName='' }) => {
      // Get base URL from environment (trailing slash already removed in apiConfig)
      const baseUrl = getSubscriptionBaseUrl();
      const fullUrl = `${baseUrl}${GET_ORDER_STATUS.url}`;
      
      console.log('Calling getOrderStatus API:', {
        url: fullUrl,
        orderId,
        merchantName,
        hasToken: !!token?.accessToken
      });

      const response = await axios.post(fullUrl, JSON.stringify({ orderId, merchantName }), {
        headers: {
          'Accept': 'application/json',
          'Authorization': token?.accessToken || '',
          'x-zupee-source': 'web',
          // 'x-zupee-env': 'cse',
          // "z-stage-env-id":"stv-prya80a3bac",
          'language': localStorage.getItem("language") || LANGUAGE,
          'Content-Type': 'application/json',
          'Package-Name': process.env.REACT_APP_APPPACKAGENAME || 'pwa.verticalbyzupee.com',
          'appname': process.env.REACT_APP_APP_NAME || 'pwa.verticalbyzupee.com',
        }
      });

      console.log('getOrderStatus Response:', response.data);
      return response.data;
    }
  );

  return {
    getOrderStatus: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    data: mutation.data,
    error: mutation.error
  };
};
